import { render, staticRenderFns } from "./CapituloTres18Page.vue?vue&type=template&id=5457c831"
import script from "./CapituloTres18Page.js?v=2?vue&type=script&lang=js&external"
export * from "./CapituloTres18Page.js?v=2?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports